module.exports = __webpack_public_path__ + "static/media/sample14.c7be844b.jpg";